export default __webpack_public_path__ + "static/media/good.c9bfdb9c.svg";